module.exports = __webpack_public_path__ + "media/components/assets/images/makeyourdream/image3-7864757aea4b433863e7825265a13633.png";